import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Icône personnalisée (avion au lieu du pin rouge)
const airplaneIcon = new L.Icon({
iconUrl: "https://cdn-icons-png.flaticon.com/512/149/149059.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
  popupAnchor: [0, -30]
});

const MapAeroports = ({ aeroports }) => {
  // Forcer aeroports à être un tableau
  const data = Array.isArray(aeroports) ? aeroports : [aeroports];

  if (!data || data.length === 0 || !data[0]) {
    return <p>Aucun aéroport trouvé.</p>;
  }

  // Centrer la carte sur le premier aéroport
  const center = [data[0].latitude, data[0].longitude];

  return (
    <div style={{ height: "300px", width: "100%", borderRadius: "10px"  }}>
      <MapContainer center={center} zoom={5} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {data.map((aeroport, index) => (
          <Marker
            key={index}
            position={[aeroport.latitude, aeroport.longitude]}
            icon={airplaneIcon}
          >
            <Popup>
              <b>{aeroport.name}</b> <br />
              {aeroport.city}, {aeroport.country}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default MapAeroports;
